module.exports = __webpack_public_path__ + "static/media/GA.1efea06c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GA.svg
// module id = 255
// module chunks = 0